import { useLoginInfo } from 'app/_hooks'
import { useRouter } from 'next/navigation'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { LoadingBackdrop } from '~/components/LoadingBackdrop'
import { RequireSignInPage } from '~/features/auth/components/RequireSignInPage'
import * as GA from '~/features/profile/libs/ga'

interface LoginStateChecker {
  children: ReactNode
}

export function LoginStateChecker({ children }: LoginStateChecker): JSX.Element {
  const { t } = useTranslation()
  const { replace, push } = useRouter()
  const loginInfo = useLoginInfo()

  const onNextProfileNewPage = () => {
    void push('/profile/new')
    GA.myProfileRequire
  }

  switch (loginInfo.status) {
    case 'notSignedIn':
      void replace('/signup')
      return <LoadingBackdrop />
    case 'noProfile':
      return (
        <RequireSignInPage
          bgType='door'
          title={t('please_create_profile')}
          message={t('you_can_check_payment_and_change_icon_if_created_profile')}
          buttonInfo={{
            text: t('create_profile'),
            onClickButton: onNextProfileNewPage,
          }}
          showLogout
        />
      )
    case 'conflict':
      return <RequireSignInPage bgType='door' title={t('incorrect_login_method')} showLogout />
    default:
      return <>{children}</>
  }
}
